export default __webpack_public_path__ + "static/media/starface.933feaaa.svg";